/**
 * InsightHubShell
 * ───────────────
 * The shared sidebar + topbar wrapper — no routing of its own.
 * Use this to give any page the Insight Hub look without being
 * inside the /imagei/* route tree.
 */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppSidebar, SidebarContext } from './components/AppSidebar';
import { Topbar } from './components/Topbar';

const AGENT_PATHS = ['/chat-agent', '/spreadsheet-agent', '/document-agent', '/tax-agent', '/labour-law'];

export default function InsightHubShell({ user, onLogout, children }) {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const isAgentRoute = AGENT_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      <div
        className="ih-root"
        style={{
          display: 'flex',
          height: '100vh',
          width: '100%',
          overflow: 'hidden',
          fontFamily: "'Inter', system-ui, sans-serif",
        }}
      >
        {!isAgentRoute && <AppSidebar />}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflow: 'hidden' }}>
          <Topbar user={user} onLogout={onLogout} />
          <main style={{ flex: 1, overflowY: 'auto', background: 'var(--background)' }}>
            {children}
          </main>
        </div>
      </div>
    </SidebarContext.Provider>
  );
}
